import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';

export const getOrderDetailsState = (state: TPlani8State) => state.orderDetailsInfo;

export const getIsSyncEnabled = createSelector(getOrderDetailsState, (state) => {
  return state.isSyncEnabled;
});

export const getShowPlanningCardLoader = createSelector(getOrderDetailsState, (state) => state.showPlanningCardLoader);

export const getPlanningCardInfo = createSelector(getOrderDetailsState, (state) => state.planningCardInfo);

export const getLearningCurveCardInfo = createSelector(getOrderDetailsState, (state) => state.learningCurveCardInfo);

export const getShowLearningCurveCardLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showLearningCurveCardLoader,
);

export const getAllLearningCurvesInfo = createSelector(getOrderDetailsState, (state) => state.allLearningCurves);

export const getShowAllLearningCurvesLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showAllLearningCurvesLoader,
);

export const getShowHeaderDetailsLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showHeaderDetailsLoader,
);

export const getHeaderInfo = createSelector(getOrderDetailsState, (state) => state.headerInfo);

export const getIsOrderShipped = createSelector(getHeaderInfo, (state) => state?.shipped ?? false);

export const getViewLearningCurveInfo = createSelector(getOrderDetailsState, (state) => state.viewLearningCurve);

export const getShowPoDetailsLoader = createSelector(getOrderDetailsState, (state) => state.showPoDetailsLoader);

export const getPoDetailsCardInfo = createSelector(getOrderDetailsState, (state) => state.poDetailsCardInfo);

export const getPoColorSizeQtyInfo = createSelector(getOrderDetailsState, (state) => state.poColorSizeQtyInfo);

export const getShowOrderAllocationLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showOrderAllocationLoader,
);

export const getAllocationCardInfo = createSelector(getOrderDetailsState, (state) => state.allocationCardInfo);

export const getOrderTimelineCardInfo = createSelector(getOrderDetailsState, (state) => state.orderTimelineCardInfo);

export const getShowOrderTimelineLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showOrderTimelineLoader,
);

export const getLinewisePlannedQtyCardInfo = createSelector(
  getOrderDetailsState,
  (state) => state.linewisePlannedQtyCardInfo,
);

export const getShowLinewisePlannedQtyLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showLinewisePlannedQtyLoader,
);

export const getShowProcessMappingDetailsLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showProcessMappingDetailsLoader,
);

export const getProcessMappingDetailsCardInfo = createSelector(
  getOrderDetailsState,
  (state) => state.processMappingDetailsCardInfo,
);

export const getObDetailsInfo = createSelector(getOrderDetailsState, (state) => state.operationBreakdownDetailsInfo);

export const getShowOperationBreakdownDetailsLoader = createSelector(
  getOrderDetailsState,
  (state) => state.showOperationBreakdownDetailsLoader,
);
